import { RegisteredTable } from "@/apis/workbook/types";
import DSDContent from "./contents/dsd-content";
import Section from "./section";
import StructureContent from "./contents/structure-content";
import XBRLContent from "./contents/xbrl-content";

const DLSection = ({
  table,
  categoryPreLabel,
}: {
  table: RegisteredTable;
  categoryPreLabel: string;
}) => {
  return (
    <>
      <Section title="DSD 원본 표">
        <DSDContent tableId={table.id} />
      </Section>
      <Section title="태깅 결과">
        <StructureContent tableId={table.id} />
      </Section>
      <Section title="XBRL 표">
        <XBRLContent tableId={table.id} categoryPreLabel={categoryPreLabel} />
      </Section>
    </>
  );
};

export default DLSection;
